export const CLEAR_DOC_TYPE_MANAGEMENT_STATE = 'CLEAR_DOC_TYPE_MANAGEMENT_STATE';

export const GET_ALL_DOC_TYPES = 'GET_ALL_DOC_TYPES';
export const GET_ALL_DOC_TYPES_SUCCESS = 'GET_ALL_DOC_TYPES_SUCCESS';
export const GET_ALL_DOC_TYPES_ERROR = 'GET_ALL_DOC_TYPES_ERROR';

export const GET_DOC_TYPE_BY_ID = 'GET_DOC_TYPE_BY_ID';
export const GET_DOC_TYPE_BY_ID_SUCCESS = 'GET_DOC_TYPE_BY_ID_SUCCESS';
export const GET_DOC_TYPE_BY_ID_ERROR = 'GET_DOC_TYPE_BY_ID_ERROR';

export const CREATE_DOC_TYPE = 'CREATE_DOC_TYPE';
export const CREATE_DOC_TYPE_SUCCESS = 'CREATE_DOC_TYPE_SUCCESS';
export const CREATE_DOC_TYPE_ERROR = 'CREATE_DOC_TYPE_ERROR';

export const UPDATE_DOC_TYPE = 'UPDATE_DOC_TYPE';
export const UPDATE_DOC_TYPE_SUCCESS = 'UPDATE_DOC_TYPE_SUCCESS';
export const UPDATE_DOC_TYPE_ERROR = 'UPDATE_DOC_TYPE_ERROR';

export const DELETE_DOC_TYPE = 'DELETE_DOC_TYPE';
export const DELETE_DOC_TYPE_SUCCESS = 'DELETE_DOC_TYPE_SUCCESS';
export const DELETE_DOC_TYPE_ERROR = 'DELETE_DOC_TYPE_ERROR';
